import { render, staticRenderFns } from "./AddRemediationBatch.vue?vue&type=template&id=546b4c3a&scoped=true"
import script from "./AddRemediationBatch.vue?vue&type=script&lang=js"
export * from "./AddRemediationBatch.vue?vue&type=script&lang=js"
import style0 from "./AddRemediationBatch.vue?vue&type=style&index=0&id=546b4c3a&prod&lang=css"
import style1 from "./AddRemediationBatch.vue?vue&type=style&index=1&id=546b4c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b4c3a",
  null
  
)

export default component.exports